module.exports = __webpack_public_path__ + "media/address.aaad3341.mp4";